import { Component, OnInit } from '@angular/core';
import { FormService } from "../../services/form.service";

@Component({
    selector: 'app-header',
    templateUrl: './header.component.html',
    styleUrls: ['./header.component.scss']
})
export class HeaderComponent implements OnInit {

	// Not used
    telephoneUrl = 'tel:00000000000';

    constructor(public formService: FormService) {
    }

    ngOnInit(): void {

    }

	public getHomeUrl() {

		return `${ window.location.origin }/`;
	}
}
